module.exports = __webpack_public_path__ + "static/media/Year-2020-background.9adaf5a1.jpg";